import { lazyStartSearch } from 'mini-mail-search-actions';
import { loadTableViewFromTableQuery } from 'mini-mail-list-actions';

/**
 * Wrapper to start search action and finish with loading the table view
 * @param startSearchCallback to be executed before the load table call
 */
export default async function startSearchAndLoadTable(startSearchCallback?: () => void) {
    lazyStartSearch.importAndExecute(loadTableViewFromTableQuery, startSearchCallback);
}
